/**
 * @description 格式化定位信息列表
 */
// 是否异常
const STATUS = {
    '0': '正常',
    '1': '异常'
};

export const formatPositionList = data => {
    if (!data.length) return [];
    data.forEach(v => {
        v.isAbnormalName = STATUS[v.isAbnormal];
    });
    return data;
};

// 轨迹类型
const TRACK_TYPE = {
    '1': 'APP',
    '5': '人工',
    '6': '北斗',
    '34': '设备',
    '50': '综合'
};
export const formatStatisticsList = data => {
    if (!data.length) return [];
    data.forEach(v => {
        v.trackingTypeName = TRACK_TYPE[v.trackingType];
    });
    return data;
};

/**
 * @description 接单点显示逻辑
 * 发运类型为整车且是中交轨迹,且第一个轨迹点的打点时间小于发车时间才显示接单点, shippingType = 1 为整车，trackType = '6'为北斗轨迹
 */
export const validateTakeOrderTime = (shippingType, trackType, takeOrderTrackingDate, realDepartureTime) => {
    const formatTakeOrderTrackingDate = new Date(takeOrderTrackingDate).getTime();
    const formatRealDepartureTime = new Date(realDepartureTime).getTime();
    if (shippingType === 1 && trackType === '6' && formatTakeOrderTrackingDate - formatRealDepartureTime < 0) {
        return true;
    }
    return false;
};
